module.exports = __webpack_public_path__ + "img/hero_image_category.3cd37c4.jpg";